import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';

interface AgeDeclarationProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

// The declaration every way of opening an account goes through. Art.
// 2-quinquies of the Italian privacy code: 14 is the age at which a person can
// consent to an information society service on their own. Nothing is stored
// server-side — a self-declaration is the "reasonable effort" Art. 8(2) GDPR
// asks for, not a record of age.
export function AgeDeclaration({ checked, onCheckedChange }: AgeDeclarationProps) {
  const policyLink = (
    <Link
      to="/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary underline underline-offset-2"
    />
  );

  return (
    <div className="flex items-start gap-3">
      <Checkbox
        id="ageConfirmation"
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        className="mt-0.5"
      />
      <Label htmlFor="ageConfirmation" className="text-sm font-normal leading-snug">
        {/* The children are the fallback; the translated string wins whenever
            the key resolves, with <policy> mapped to the link. */}
        <Trans i18nKey="auth.ageConfirmation" components={{ policy: policyLink }}>
          I am at least 14 years old and I have read the{' '}
          <Link
            to="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2"
          >
            privacy policy
          </Link>
          .
        </Trans>
      </Label>
    </div>
  );
}
